// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"6728d64a","802":"c7c0a54a"}[chunkId] + ".chunk.js";
};